module.exports = __webpack_public_path__ + "img/architecture.981b14ee.png";